/**
 * Single source of truth for validating/normalizing property lat-lng pairs.
 * A valid coordinate is an object with finite numeric lat and lng (rejects
 * undefined, strings, and NaN — note NaN is typeof "number").
 */
export const isValidCoordinates = (c) =>
  !!c &&
  typeof c.lat === "number" &&
  Number.isFinite(c.lat) &&
  typeof c.lng === "number" &&
  Number.isFinite(c.lng);

/** Returns a clean { lat, lng } object, or null if invalid. */
export const normalizeCoordinates = (c) =>
  isValidCoordinates(c) ? { lat: c.lat, lng: c.lng } : null;
